<template>
  <div class="calculator-hero">
    <h1 class="calculator-hero__title" data-testid="btccalculator">
      {{ headingText }}
    </h1>
    <div class="calculator-hero__content">
      <Calculator @crypto-changed="handleCryptoChange" />
    </div>
    <PromoCampaign v-if="promoInfo" :promoInfo="promoInfo" class="calculator-hero__promo" />
    <div class="calculator-hero__content">
      <CalculatorBuyNow :link-params="promoLinkParams">
        {{ ctaText }}
      </CalculatorBuyNow>
      <CalculatorCurrentPrice />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, defineProps } from "vue";

import Calculator from "@kano/components/Calculator/Calculator.vue";
import CalculatorBuyNow from "@kano/components/Calculator/CalculatorBuyNow.vue";
import PromoCampaign from "@kano/components/Calculator/PromoCampaign.vue";
import { i18n } from '@kano/i18n';
import store from "@/store/calculator";
import CalculatorCurrentPrice from "@kano/components/Calculator/CalculatorCurrentPrice.vue";

const props = defineProps<{
  promoInfo: { code: string, expirationDate: Date } | null,
}>();

const headingText = computed(() => store.state.calculator.heading);

const selectedCryptoName = computed(() => store.state.calculator.selectedCryptoCurrency.name);

const promoLinkParams = computed(() => (
  props.promoInfo ? { promoCode: props.promoInfo.code } : {}
));

const ctaText = computed(() => {
  if (props.promoInfo) {
    return i18n.t('calculator.promotion-campaign.cta-button-label', {
      cryptoName: selectedCryptoName.value,
    });
  }

  return i18n.t('calculator.buyNow');
});

const handleCryptoChange = (cryptoCurrency) => {
  store.dispatch("calculator/requestUsdAggregatePrice", cryptoCurrency);
}
</script>
